module.exports = __webpack_public_path__ + "img/brand-r.81df6651.jpg";